import type { PPAScopeFilter, PPAViewDataSource } from 'types/ppaViews';

import {
    VIEW_NAME_DUPLICATE_ERROR,
    VIEW_NAME_PATTERN,
    VIEW_NAME_SPECIAL_CHARS_ERROR,
} from './savedViewStateSelect.constants';
import type { AppliedScopeInput, SaveViewFormState } from './SavedViewStateSelect.types';

export type ViewWorkspaceSelection = {
    viewId: number | null;
    dataSource?: PPAViewDataSource;
};

/** True when a named saved view is loaded (not scenario-only / emdash state). */
export const isSavedViewLoadedInWorkspace = (selection: ViewWorkspaceSelection): boolean =>
    selection.viewId != null && selection.dataSource === 'view';

export const initialSaveViewFormState: SaveViewFormState = {
    viewName: '',
    includeAppliedFilters: true,
    setAsDefault: false,
};

export const getViewNameValidationError = (
    viewName: string,
    existingNames: string[] = [],
    excludeName?: string,
): string | null => {
    if (!viewName) {
        return null;
    }

    if (!VIEW_NAME_PATTERN.test(viewName)) {
        return VIEW_NAME_SPECIAL_CHARS_ERROR;
    }

    const trimmed = viewName.trim().toLowerCase();
    if (!trimmed) {
        return null;
    }

    const exclude = excludeName?.trim().toLowerCase() ?? '';
    const isDuplicate = existingNames.some((existing) => {
        const normalized = existing.trim().toLowerCase();
        return normalized === trimmed && normalized !== exclude;
    });

    if (isDuplicate) {
        return VIEW_NAME_DUPLICATE_ERROR;
    }

    return null;
};

export const normalizeAppliedScope = (scope: AppliedScopeInput[]): PPAScopeFilter[] =>
    scope
        .filter((item) => item.dimension && item.attribute_type)
        .map((item) => ({
            dimension: item.dimension!,
            attribute_type: item.attribute_type!,
            attribute_ex_id: item.attribute_ex_id ?? [],
        }));
